export default class DashboardSingleData {
    constructor(description, number, percent, increase, positive) {
        this._description = description;
        this._number = number;
        this._percent = percent;
        this._increase = increase;
        this._positive = positive;
    }
    get description() {
        return this._description;
    }

    get number() {
        return this._number;
    }

    get percent() {
        return this._percent;
    }

    get increase() {
        return this._increase;
    }

    get positive() {
        return this._positive;
    }
}
